export const FAQs = [
  {
    title: "Performance",
    questions: [
      "Which targeting in keyword targeting have the highest Advertising Cost of Sale (ACOS) in sponsored brand type ad campaigns?",
      "Which advertised asin are achieving a Cost Per Acquisition (CPA) between 10 and 50?",
      "List targeting in ASIN targeting with a Cost Per Click (CPC) greater than 100 and less than 500 total impressions.",
    ],
  },
  {
    title: "Strategic Planning",
    questions: [
      "Show me targeting in keyword targeting that has Grown in CPC more than 10% and ROAS has Degrown is more than 10% in last 14 Days",
      "Show me advertised asin that has Grown in Orders more than 50% & Spend has Grown more than 10% in in this week compared to previous week",
      "Show me targeting in keyword targeting with ROAS < 1 and Spend > 1000",
    ],
  },
  {
    title: "Trend",
    questions: [
      "Show me targeting in category targeting that has Grown in Sales Yesterday",
      "How has the average CPC changed from last month to this month for each adFormat and campaign type?",
      "Show me advertised asin that has Grown in Sales Yesterday",
    ],
  },
];

export const dataSetIds = [
  {
    title: "Attribution: BearGrips (US)",
    id: "AttributionBearGripsUSUSec345a258d447374al",
  },
  {
    title: "Bear Grips",
    id: "BearGripsUSec345a258d447374sl",
  },
  {
    title: "Boult",
    id: "BoultINa02b132114912c49vl",
  },
  // {
  //   title: "BeBodywise",
  //   id: "BeBodywiseINcdc29c953152085a",
  // },
  // {
  //   title: "Blue Nectar",
  //   id: "BlueNectarINd9ec711c80faee54",
  // },
  {
    title: "Campus",
    id: "CampusIN77061c54e1a2c807",
  },
  {
    title: "Carat Craze US",
    id: "CaratCrazeUScdc29c953152085a",
  },
  {
    title: "Carat Craze CA",
    id: "CaratCrazeCA07390ecba2dfabf9ba3dfsd",
  },
  // {
  //   title: "Farmley",
  //   id: "FarmleyIN2277c7532c26f8b9vl",
  // },
  {
    title: "Kapiva Ayurveda",
    id: "KapivaAyurvedaIN8097d7586cc6a648",
  },
  // {
  //   title: "Man Matters",
  //   id: "ManMattersINcdc29c953152085a",
  // },
  {
    title: "Nirvana Being",
    id: "NirvanaBeingINd4b97fafb750836e",
  },
  // {
  //   title: "Noise",
  //   id: "NoiseIN4eca1d24410ae2d3",
  // },
  {
    title: "Nua",
    id: "NuaINcdc29c953152085a",
  },
  {
    title: "Nurturing Greens",
    id: "NurturingGreenIN966334f067838cf06cee1vd",
  },
  {
    title: "Nutrova",
    id: "NutrovaINd600374d517406b8",
  },
  // {
  //   title: "Orient Electric",
  //   id: "OrientElectricIN4020745517c7371ac2d87vd",
  // },
  // {
  //   title: "Pilgrim India",
  //   id: "PilgrimIndiaINcdc29c953152085a",
  // },
  // {
  //   title: "Relaxo",
  //   id: "RELAXOFOOTWEARSLIMITEDIN8cbd9691fcb44ee8",
  // },
  // {
  //   title: "SlurrpFarm",
  //   id: "SlurrpFarmIN610a7b9abceaea9dvl",
  // },
  {
    title: "Sparx",
    id: "SPARXIN58cdc530a51e7337",
  },
  {
    title: "SS - Bear Grips - US",
    id: "SSBearGripsUSUSec345a258d447374al",
  },

  {
    title: "TAC",
    id: "TACTheAyurvedaCoINa949efc961ab21fa",
  },
  // {
  //   title: "",
  //   id: "",
  // },
  // {
  //   title: "Boult",
  //   id: "BoultINa02b132114912c49vl",
  // },
];

export const tableOptions = [
  {
    name: "Advertised Products Summary",
    id: "advertisedProduct_chatbot",
  },
  {
    name: "Placement Summary",
    id: "placement_chatbot",
  },
  {
    name: "Search Term Summary",
    id: "searchTerm_chatbot",
  },
  {
    name: "Targeting Summary",
    id: "targeting_chatbot",
  },
  {
    name: "Seller Central Summary",
    id: "seller_chatbot",
  },
  {
    name: "Vendor Central Summary",
    id: "vendor_chatbot",
  },
];
